<template>
    <div class="close-header-title no-con">
        <section class="privacy-section">
            <div class="container">
                <div v-if="showStripeConnectNotice" class="row mb-3">
                    <div class="col-12">
                        <div
                            class="stripe-dashboard-notice"
                            :class="stripeNoticeClass"
                            role="button"
                            tabindex="0"
                            @click="handleStripeNoticeClick"
                            @keyup.enter="handleStripeNoticeClick"
                        >
                            <div class="stripe-dashboard-notice__content">
                                <strong>{{ stripeNoticeTitle }}</strong>
                                <p class="mb-0">{{ stripeNoticeText }}</p>
                            </div>
                            <span v-if="stripeConnectState !== 'pending'" class="stripe-dashboard-notice__action">
                                {{ $t('stripe_connect.dashboard_notice_action') }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row gap-3">
                    <div class="col-md-6 col-xl-4" v-if="this.loginUser.id == 1">
                        <div class="widget widget-blue widget-stat bg-inverse text-white">
                            <div class="widget-stat-btn"><a @click.prevent="get_state()"><i
                                        class="fa fa-repeat"></i></a>
                            </div>
                            <div class="widget-stat-icon">
                                <span class="widget-icon"><i class="fa fa-users"></i></span>
                            </div>
                            <div class="widget-stat-info">
                                <div class="widget-stat-number">{{ this.stats.users }}</div>
                                <div class="widget-stat-title">{{ $t('dashboard.users') }}</div>
                                <div class="widget-stat-text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4">
                        <div class="widget widget-green widget-stat bg-success1 text-white">
                            <div class="widget-stat-btn"><a @click.prevent="get_state()"><svg width="104" height="101"
                                        viewBox="0 0 104 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.15"
                                            d="M92.7914 22.6469H72.6647V10.6668C72.6647 4.96764 68.0267 0.3125 62.3105 0.3125H41.4993C35.8001 0.3125 31.145 4.95053 31.145 10.6668V39.2993H11.0183C5.31921 39.2993 0.664062 43.9374 0.664062 49.6536V100.312H103.129V32.9841C103.129 27.2849 98.4905 22.6298 92.7743 22.6298L92.7914 22.6469ZM31.145 91.7553H9.22131V49.6536C9.22131 48.661 10.0257 47.8566 11.0183 47.8566H31.145V91.7553ZM64.1075 91.7553H39.7022V10.6668C39.7022 9.67413 40.5066 8.86975 41.4993 8.86975H62.3105C63.3031 8.86975 64.1075 9.67413 64.1075 10.6668V91.7553ZM94.5713 91.7553H72.6476V31.2042H92.7743C93.7669 31.2042 94.5713 32.0085 94.5713 33.0012V91.7553Z"
                                            fill="white" />
                                    </svg>
                                </a>
                            </div>
                            <div class="widget-stat-icon"><svg width="101" height="101" viewBox="0 0 101 101"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50.1289" cy="50.3125" r="50" fill="white" />
                                    <path
                                        d="M70.5764 36.4797H60.513V30.4896C60.513 27.6401 58.194 25.3125 55.3359 25.3125H44.9303C42.0807 25.3125 39.7532 27.6315 39.7532 30.4896V44.8059H29.6898C26.8403 44.8059 24.5127 47.1249 24.5127 49.983V75.3125H75.7449V41.6483C75.7449 38.7987 73.4259 36.4712 70.5678 36.4712L70.5764 36.4797ZM39.7532 71.0339H28.7913V49.983C28.7913 49.4867 29.1935 49.0845 29.6898 49.0845H39.7532V71.0339ZM56.2344 71.0339H44.0318V30.4896C44.0318 29.9933 44.434 29.5911 44.9303 29.5911H55.3359C55.8322 29.5911 56.2344 29.9933 56.2344 30.4896V71.0339ZM71.4663 71.0339H60.5045V40.7583H70.5678C71.0641 40.7583 71.4663 41.1605 71.4663 41.6568V71.0339Z"
                                        fill="#70D3FF" />
                                </svg>
                            </div>
                            <div class="widget-stat-info">
                                <div class="widget-stat-number">{{ this.stats.properties }}</div>
                                <div class="widget-stat-title">{{ $t('dashboard.properties') }}</div>
                                <div class="widget-stat-text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4">
                        <div class="widget widget-yellow widget-stat bg-primary1 text-white">
                            <div class="widget-stat-btn"><a @click.prevent="get_state()"><svg width="107" height="101"
                                        viewBox="0 0 107 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.15"
                                            d="M79.4672 46.9883C64.7689 46.9883 52.8051 58.952 52.8051 73.6504C52.8051 88.3487 64.7689 100.312 79.4672 100.312C94.1656 100.312 106.129 88.3487 106.129 73.6504C106.129 58.952 94.1656 46.9883 79.4672 46.9883ZM79.4672 92.2968C69.1784 92.2968 60.8208 83.9392 60.8208 73.6504C60.8208 63.3615 69.1784 55.004 79.4672 55.004C89.7561 55.004 98.1136 63.3615 98.1136 73.6504C98.1136 83.9392 89.7561 92.2968 79.4672 92.2968ZM39.6791 48.8512H17.9222V56.8669H39.6791V48.8512ZM39.6791 75.5646V67.5489H18.0076V75.5646H39.6791ZM8.40244 78.4359V41.126H91.3113V20.8731C91.3113 13.3188 85.1756 7.18312 77.6214 7.18312H67.4351V0.3125H59.4194V7.18312H32.2958V0.3125H24.2801V7.18312H14.0938C6.53951 7.18312 0.386719 13.3188 0.386719 20.8731V78.4359C0.386719 85.9902 6.53951 92.1259 14.0767 92.1259H45.849V84.1101H14.0767C10.949 84.1101 8.40244 81.5636 8.40244 78.4359ZM8.40244 20.8731C8.40244 17.7454 10.949 15.1988 14.0767 15.1988H24.263V22.0695H32.2787V15.1988H59.4023V22.0695H67.418V15.1988H77.6043C80.732 15.1988 83.2785 17.7454 83.2785 20.8731V33.1103H8.40244V20.8731ZM81.8771 59.2597H77.0574V76.0602H91.6361V71.2405H81.86V59.2597H81.8771Z"
                                            fill="white" />
                                    </svg>
                                </a>
                            </div>
                            <div class="widget-stat-icon"><svg width="101" height="101" viewBox="0 0 101 101"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50.1289" cy="50.3125" r="50" fill="white" />
                                    <path
                                        d="M63.2336 48.6504C55.8844 48.6504 49.9026 54.6323 49.9026 61.9814C49.9026 69.3306 55.8844 75.3125 63.2336 75.3125C70.5828 75.3125 76.5647 69.3306 76.5647 61.9814C76.5647 54.6323 70.5828 48.6504 63.2336 48.6504ZM63.2336 71.3046C58.0892 71.3046 53.9104 67.1259 53.9104 61.9814C53.9104 56.837 58.0892 52.6583 63.2336 52.6583C68.378 52.6583 72.5568 56.837 72.5568 61.9814C72.5568 67.1259 68.378 71.3046 63.2336 71.3046ZM43.3396 49.5819H32.4611V53.5897H43.3396V49.5819ZM43.3396 62.9385V58.9307H32.5038V62.9385H43.3396ZM27.7012 64.3742V45.7193H69.1557V35.5928C69.1557 31.8157 66.0878 28.7478 62.3107 28.7478H57.2175V25.3125H53.2097V28.7478H39.6479V25.3125H35.64V28.7478H30.5469C26.7698 28.7478 23.6934 31.8157 23.6934 35.5928V64.3742C23.6934 68.1513 26.7698 71.2192 30.5383 71.2192H46.4245V67.2113H30.5383C28.9745 67.2113 27.7012 65.938 27.7012 64.3742ZM27.7012 35.5928C27.7012 34.029 28.9745 32.7557 30.5383 32.7557H35.6315V36.191H39.6394V32.7557H53.2011V36.191H57.209V32.7557H62.3021C63.866 32.7557 65.1393 34.029 65.1393 35.5928V41.7114H27.7012V35.5928ZM64.4385 54.7861H62.0287V63.1864H69.318V60.7765H64.43V54.7861H64.4385Z"
                                        fill="#39BF5E" />
                                </svg>
                            </div>
                            <div class="widget-stat-info">
                                <div class="widget-stat-number">{{ this.stats.bookings }}</div>
                                <div class="widget-stat-title">{{ $t('dashboard.bookings') }}</div>
                                <div class="widget-stat-text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4" v-if="this.loginUser.id != 1">
                        <div class="widget widget-stat bg-inverse1 text-white">
                            <div class="widget-stat-btn"><a @click.prevent="get_state()"><svg width="85" height="101"
                                        viewBox="0 0 85 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.15"
                                            d="M35.8864 93.2835H11.1993C9.26202 93.2835 7.68479 91.7063 7.68479 89.769V10.8731C7.68479 8.93585 9.26202 7.35862 11.1993 7.35862H70.1226C72.0599 7.35862 73.6371 8.93585 73.6371 10.8731V40.2748C73.6371 42.2292 75.2144 43.7893 77.1516 43.7893C79.0889 43.7893 80.6661 42.212 80.6661 40.2748V10.8731C80.6661 5.0442 75.9173 0.3125 70.1055 0.3125H11.1993C5.38751 0.3125 0.638672 5.06134 0.638672 10.8731V89.7519C0.638672 95.5808 5.38751 100.312 11.1993 100.312H35.8864C37.8408 100.312 39.4009 98.7353 39.4009 96.798C39.4009 94.8608 37.8237 93.2835 35.8864 93.2835ZM32.7148 75.5739H17.4568C15.5024 75.5739 13.9423 77.1512 13.9423 79.0884C13.9423 81.0257 15.5195 82.6029 17.4568 82.6029H32.7148C34.6692 82.6029 36.2293 81.0257 36.2293 79.0884C36.2293 77.1512 34.652 75.5739 32.7148 75.5739ZM32.7148 56.39H17.4568C15.5024 56.39 13.9423 57.9672 13.9423 59.9045C13.9423 61.8417 15.5195 63.419 17.4568 63.419H32.7148C34.6692 63.419 36.2293 61.8417 36.2293 59.9045C36.2293 57.9672 34.652 56.39 32.7148 56.39ZM81.1976 93.8664H79.6203C79.6203 93.7464 79.6375 93.6264 79.6375 93.4892V84.8145C79.6375 84.043 79.3289 83.2887 78.7803 82.7401L71.0656 75.0425L78.7803 67.3278C79.3289 66.7792 79.6375 66.042 79.6375 65.2533V55.8414H81.1976C82.8091 55.8414 84.1292 54.5213 84.1292 52.9098C84.1292 51.2983 82.8091 49.9782 81.1976 49.9782H52.3959C50.7844 49.9782 49.4643 51.2983 49.4643 52.9098C49.4643 54.5213 50.7844 55.8414 52.3959 55.8414H53.956V65.0133C53.956 65.7848 54.2646 66.5391 54.8132 67.0877L62.7679 75.0425L54.8132 82.9972C54.2646 83.5458 53.956 84.283 53.956 85.0716V93.5064C53.956 93.6435 53.956 93.7464 53.9732 93.8836H52.3959C50.7844 93.8836 49.4643 95.2036 49.4643 96.8152C49.4643 98.4267 50.7844 99.7467 52.3959 99.7467H81.1976C82.8091 99.7467 84.1292 98.4267 84.1292 96.8152C84.1292 95.2036 82.8091 93.8664 81.1976 93.8664ZM59.8192 63.7961V55.8414H73.7571V64.0361L66.8996 70.8937L59.8021 63.7961H59.8192ZM59.8192 93.8664C59.8192 93.7464 59.8363 93.6264 59.8363 93.4892V86.2546L66.9339 79.157L73.7914 86.0145V93.4721C73.7914 93.6093 73.7914 93.7121 73.8086 93.8493H59.8192V93.8664ZM67.4139 40.7205C67.4139 38.7661 65.8367 37.206 63.8994 37.206H17.4568C15.5024 37.206 13.9423 38.7833 13.9423 40.7205C13.9423 42.6578 15.5195 44.235 17.4568 44.235H63.8994C65.8367 44.235 67.4139 42.6578 67.4139 40.7205ZM63.8823 18.0221H17.4568C15.5024 18.0221 13.9423 19.5993 13.9423 21.5366C13.9423 23.4738 15.5195 25.0511 17.4568 25.0511H63.8994C65.8538 25.0511 67.4139 23.4738 67.4139 21.5366C67.4139 19.5993 65.8367 18.0221 63.8823 18.0221Z"
                                            fill="white" />
                                    </svg>
                                </a>
                            </div>
                            <div class="widget-stat-icon"><svg width="101" height="101" viewBox="0 0 101 101"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="50.1289" cy="50.3125" r="50" fill="white" />
                                    <path
                                        d="M46.8797 71.798H34.5362C33.5675 71.798 32.7789 71.0094 32.7789 70.0408V30.5928C32.7789 29.6242 33.5675 28.8356 34.5362 28.8356H63.9978C64.9665 28.8356 65.7551 29.6242 65.7551 30.5928V45.2936C65.7551 46.2708 66.5437 47.0509 67.5123 47.0509C68.481 47.0509 69.2696 46.2623 69.2696 45.2936V30.5928C69.2696 27.6783 66.8952 25.3125 63.9893 25.3125H34.5362C31.6303 25.3125 29.2559 27.6869 29.2559 30.5928V70.0322C29.2559 72.9466 31.6303 75.3125 34.5362 75.3125H46.8797C47.8569 75.3125 48.637 74.5239 48.637 73.5553C48.637 72.5866 47.8484 71.798 46.8797 71.798ZM45.2939 62.9432H37.6649C36.6877 62.9432 35.9077 63.7318 35.9077 64.7005C35.9077 65.6691 36.6963 66.4577 37.6649 66.4577H45.2939C46.2711 66.4577 47.0512 65.6691 47.0512 64.7005C47.0512 63.7318 46.2625 62.9432 45.2939 62.9432ZM45.2939 53.3512H37.6649C36.6877 53.3512 35.9077 54.1399 35.9077 55.1085C35.9077 56.0771 36.6963 56.8657 37.6649 56.8657H45.2939C46.2711 56.8657 47.0512 56.0771 47.0512 55.1085C47.0512 54.1399 46.2625 53.3512 45.2939 53.3512ZM69.5353 72.0895H68.7467C68.7467 72.0295 68.7553 71.9694 68.7553 71.9009V67.5635C68.7553 67.1777 68.601 66.8006 68.3267 66.5263L64.4693 62.6775L68.3267 58.8201C68.601 58.5458 68.7553 58.1772 68.7553 57.7829V53.0769H69.5353C70.3411 53.0769 71.0011 52.4169 71.0011 51.6111C71.0011 50.8054 70.3411 50.1453 69.5353 50.1453H55.1345C54.3287 50.1453 53.6687 50.8054 53.6687 51.6111C53.6687 52.4169 54.3287 53.0769 55.1345 53.0769H55.9145V57.6629C55.9145 58.0487 56.0688 58.4258 56.3431 58.7001L60.3205 62.6775L56.3431 66.6549C56.0688 66.9292 55.9145 67.2978 55.9145 67.6921V71.9094C55.9145 71.978 55.9145 72.0295 55.9231 72.098H55.1345C54.3287 72.098 53.6687 72.7581 53.6687 73.5638C53.6687 74.3696 54.3287 75.0296 55.1345 75.0296H69.5353C70.3411 75.0296 71.0011 74.3696 71.0011 73.5638C71.0011 72.7581 70.3411 72.0895 69.5353 72.0895ZM58.8461 57.0543V53.0769H65.8151V57.1743L62.3863 60.6031L58.8375 57.0543H58.8461ZM58.8461 72.0895C58.8461 72.0295 58.8547 71.9694 58.8547 71.9009V68.2835L62.4035 64.7348L65.8322 68.1635V71.8923C65.8322 71.9609 65.8322 72.0123 65.8408 72.0809H58.8461V72.0895ZM62.6435 45.5165C62.6435 44.5393 61.8549 43.7593 60.8862 43.7593H37.6649C36.6877 43.7593 35.9077 44.5479 35.9077 45.5165C35.9077 46.4851 36.6963 47.2738 37.6649 47.2738H60.8862C61.8549 47.2738 62.6435 46.4851 62.6435 45.5165ZM60.8777 34.1673H37.6649C36.6877 34.1673 35.9077 34.9559 35.9077 35.9245C35.9077 36.8932 36.6963 37.6818 37.6649 37.6818H60.8862C61.8634 37.6818 62.6435 36.8932 62.6435 35.9245C62.6435 34.9559 61.8549 34.1673 60.8777 34.1673Z"
                                        fill="#F2B601" />
                                </svg>
                            </div>
                            <div class="widget-stat-info" style="margin-top: 10px;">
                                <div class="widget-stat-number">{{ this.stats.pending }}</div>
                                <div class="widget-stat-title">{{ $t('dashboard.pending_approve') }}</div>
                                <div class="widget-stat-text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4" v-if="this.loginUser.id == 1">
                        <div class="widget widget-stat bg-inverse1 text-white">
                            <div class="widget-stat-btn"><a @click.prevent="get_state()"><i
                                        class="fa fa-repeat"></i></a>
                            </div>
                            <div class="widget-stat-icon">
                                <span class="widget-icon">
                                    <i class="fa fa-ban"></i>
                                </span>
                            </div>
                            <div class="widget-stat-info">
                                <div class="widget-stat-number">{{ this.stats.pending }}</div>
                                <div class="widget-stat-title">{{ $t('dashboard.pending_approve') }}</div>
                                <div class="widget-stat-text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4" v-if="this.loginUser.id == 1">
                        <div class="widget widget-stat bg-refund text-white">
                            <div class="widget-stat-btn"><a @click.prevent="get_state()"><i
                                        class="fa fa-repeat"></i></a>
                            </div>
                            <div class="widget-stat-icon">
                                <span class="widget-icon">
                                    <i class="fa fa-undo"></i>
                                </span>
                            </div>
                            <div class="widget-stat-info">
                                <div class="widget-stat-number">{{ this.stats.pending_refunds_count }}</div>
                                <div class="widget-stat-title">{{ $t('dashboard.pending_refunds') }}</div>
                                <div class="widget-stat-text"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-4" v-if="this.loginUser.id == 1">
                        <div class="widget widget-stat bg-cancellation text-white">
                            <div class="widget-stat-btn"><a @click.prevent="get_state()"><i
                                        class="fa fa-repeat"></i></a>
                            </div>
                            <div class="widget-stat-icon">
                                <span class="widget-icon">
                                    <i class="fa fa-times-circle"></i>
                                </span>
                            </div>
                            <div class="widget-stat-info">
                                <div class="widget-stat-number">{{ this.stats.pending_cancellations_count }}</div>
                                <div class="widget-stat-title">{{ $t('dashboard.cancellations') }}</div>
                                <div class="widget-stat-text"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5" v-if="loginUser.id !== 1">
                    <div class="col-12 mb-4">
                        <h3 class="font-weight-bold" style="color: #2c3e50;">{{ $t('dashboard.how_vanovy_works') }}</h3>
                        <p class="text-muted">{{ $t('dashboard.how_vanovy_works_desc') }}</p>
                    </div>
                    
                    <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-sm border-0" style="border-radius: 12px; transition: transform 0.2s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="icon-box" style="background: rgba(46, 204, 113, 0.1); color: #2ecc71; border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                                        <i class="fa fa-percent fa-lg"></i>
                                    </div>
                                    <h5 class="card-title mb-0 font-weight-bold">{{ $t('dashboard.commission_title') }}</h5>
                                </div>
                                <p class="card-text text-muted" style="line-height: 1.6;" v-html="$t('dashboard.commission_desc')"></p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-sm border-0" style="border-radius: 12px; transition: transform 0.2s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="icon-box" style="background: rgba(52, 152, 219, 0.1); color: #3498db; border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                                        <i class="fa fa-shield fa-lg"></i>
                                    </div>
                                    <h5 class="card-title mb-0 font-weight-bold">{{ $t('dashboard.security_deposit_title') }}</h5>
                                </div>
                                <p class="card-text text-muted" style="line-height: 1.6;">{{ $t('dashboard.security_deposit_desc') }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-sm border-0" style="border-radius: 12px; transition: transform 0.2s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="icon-box" style="background: rgba(155, 89, 182, 0.1); color: #9b59b6; border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                                        <i class="fa fa-undo fa-lg"></i>
                                    </div>
                                    <h5 class="card-title mb-0 font-weight-bold">{{ $t('dashboard.refunds_title') }}</h5>
                                </div>
                                <p class="card-text text-muted" style="line-height: 1.6;">{{ $t('dashboard.refunds_desc') }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-sm border-0" style="border-radius: 12px; transition: transform 0.2s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="icon-box" style="background: rgba(241, 196, 15, 0.1); color: #f39c12; border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                                        <i class="fa fa-money fa-lg"></i>
                                    </div>
                                    <h5 class="card-title mb-0 font-weight-bold">{{ $t('dashboard.payments_title') }}</h5>
                                </div>
                                <p class="card-text text-muted" style="line-height: 1.6;">{{ $t('dashboard.payments_desc') }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-sm border-0" style="border-radius: 12px; transition: transform 0.2s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="icon-box" style="background: rgba(230, 126, 34, 0.1); color: #d35400; border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                                        <i class="fa fa-check-square-o fa-lg"></i>
                                    </div>
                                    <h5 class="card-title mb-0 font-weight-bold">{{ $t('dashboard.accepting_requests_title') }}</h5>
                                </div>
                                <p class="card-text text-muted" style="line-height: 1.6;">{{ $t('dashboard.accepting_requests_desc') }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-sm border-0" style="border-radius: 12px; transition: transform 0.2s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="icon-box" style="background: rgba(231, 76, 60, 0.1); color: #c0392b; border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                                        <i class="fa fa-bell fa-lg"></i>
                                    </div>
                                    <h5 class="card-title mb-0 font-weight-bold">{{ $t('dashboard.notifications_title') }}</h5>
                                </div>
                                <p class="card-text text-muted" style="line-height: 1.6;">{{ $t('dashboard.notifications_desc') }}</p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-12 mb-4">
                        <div class="card h-100 shadow-sm border-0" style="border-radius: 12px; transition: transform 0.2s;" onmouseover="this.style.transform='translateY(-5px)'" onmouseout="this.style.transform='translateY(0)'">
                            <div class="card-body p-4">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="icon-box" style="background: rgba(52, 73, 94, 0.1); color: #34495e; border-radius: 50%; width: 45px; height: 45px; display: flex; align-items: center; justify-content: center; margin-right: 15px;">
                                        <i class="fa fa-comments fa-lg"></i>
                                    </div>
                                    <h5 class="card-title mb-0 font-weight-bold">{{ $t('dashboard.communication_title') }}</h5>
                                </div>
                                <p class="card-text text-muted" style="line-height: 1.6;">{{ $t('dashboard.communication_desc') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import API from '@/api';
import {
    STRIPE_STATE_NONE,
    STRIPE_STATE_PENDING,
    STRIPE_STATE_REJECTED,
    STRIPE_STATE_VERIFIED,
    resolveStripeConnectState,
    canAcceptBookingPayments,
} from '@/utils/stripeConnectStatus';

export default {
    name: 'Dashboard',
    data() {
        return {
            loginUser: '',
            stats: '',
            stripeConnectAccount: null,
            stripeConnectMeta: {},
            stripeConnectState: null,
        };
    },
    computed: {
        isPropertyOwnerDashboard() {
            return this.loginUser && this.loginUser.id !== 1;
        },
        showStripeConnectNotice() {
            return this.isPropertyOwnerDashboard
                && this.stripeConnectState
                && this.stripeConnectState !== STRIPE_STATE_VERIFIED;
        },
        stripeNoticeClass() {
            if (this.stripeConnectState === STRIPE_STATE_PENDING) return 'is-pending';
            if (this.stripeConnectState === STRIPE_STATE_REJECTED) return 'is-rejected';
            return 'is-setup';
        },
        stripeNoticeTitle() {
            if (this.stripeConnectState === STRIPE_STATE_PENDING) {
                return this.$t('stripe_connect.verification_pending_title');
            }
            if (this.stripeConnectState === STRIPE_STATE_REJECTED) {
                return this.$t('stripe_connect.verification_rejected_title');
            }
            return this.$t('stripe_connect.setup_required_title');
        },
        stripeNoticeText() {
            if (this.stripeConnectState === STRIPE_STATE_PENDING) {
                return this.$t('stripe_connect.dashboard_notice_pending');
            }
            if (this.stripeConnectState === STRIPE_STATE_REJECTED) {
                return this.$t('stripe_connect.dashboard_notice_rejected');
            }
            return this.$t('stripe_connect.dashboard_notice_setup');
        },
    },
    async mounted() {
        const user = JSON.parse(localStorage.getItem('user'));
        this.loginUser = user;
        this.get_state();

        if (this.isPropertyOwnerDashboard) {
            await this.loadStripeConnectStatus();
        }

        if (this.$route.query.stripe_pending === '1') {
            await this.$swal({
                icon: 'info',
                type: 'info',
                title: this.$t('stripe_connect.verification_pending_title'),
                text: this.$t('stripe_connect.verification_pending_text'),
            });
            this.$router.replace({ path: '/dashboard' });
        }
    },
    methods: {
        get_state() {
            API.getdashboardstats(this.loginUser.id, (fevData) => {
                this.stats = fevData.data;
            });
        },
        loadStripeConnectStatus() {
            return new Promise((resolve) => {
                API.getConnectAccount((data) => {
                    this.stripeConnectAccount = data.data || null;
                    this.stripeConnectMeta = {
                        stripe_state: data.stripe_state,
                        can_accept_payments: data.can_accept_payments,
                    };
                    this.stripeConnectState = resolveStripeConnectState(
                        this.stripeConnectAccount,
                        this.stripeConnectMeta
                    );
                    const verified = canAcceptBookingPayments(
                        this.stripeConnectAccount,
                        this.stripeConnectMeta
                    );
                    localStorage.setItem('stripeVerified', verified ? 'true' : 'false');
                    resolve();
                }, () => {
                    this.stripeConnectAccount = null;
                    this.stripeConnectMeta = {};
                    this.stripeConnectState = STRIPE_STATE_NONE;
                    localStorage.setItem('stripeVerified', 'false');
                    resolve();
                });
            });
        },
        goToStripeOnboarding() {
            this.$router.push({
                path: '/add_property',
                query: { from: 'dashboard', setup: 'stripe' },
            });
        },
        handleStripeNoticeClick() {
            if (this.stripeConnectState === STRIPE_STATE_PENDING) {
                this.$swal({
                    icon: 'info',
                    type: 'info',
                    title: this.$t('stripe_connect.verification_pending_title'),
                    text: this.$t('stripe_connect.verification_pending_text'),
                });
                return;
            }
            this.goToStripeOnboarding();
        },
    },
};
</script>
<style>
.stripe-dashboard-notice {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px;
    border-radius: 12px;
    cursor: pointer;
}

.stripe-dashboard-notice.is-setup {
    border: 1px solid #e9101042;
    background: #ff572236;
    color: #ee1111b0;
}

.stripe-dashboard-notice.is-setup .stripe-dashboard-notice__action {
    color: #ee1111b0;
}

.stripe-dashboard-notice.is-pending {
    border-color: #ffe08a;
    background: #f9e9b2c4;
    color: #6b4f00;
    cursor: default;
}

.stripe-dashboard-notice.is-rejected {
    border-color: #f5b7b1;
    background: #fdecea;
    color: #7b241c;
}

.stripe-dashboard-notice__content p {
    margin-top: 6px;
    font-size: 14px;
}

.stripe-dashboard-notice__action {
    flex-shrink: 0;
    font-weight: 600;
    text-decoration: underline;
    white-space: nowrap;
}

.privacy-section .container {
    max-width: 100%;
}

.widget.widget-stat {
    text-align: center;
    height: 100%;
    max-height: 150px;
    min-height: 150px;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    align-items: center;
}

.widget-stat-btn a {
    width: 80px;
    height: 80px;
}

.widget-stat-btn svg {
    max-width: 70px;
    height: 70px;
}

.text-white {
    color: #fff;
}

.bg-inverse {
    background: #69D4FF !important;
}

.bg-inverse1 {
    background: #F2B601 !important;
}

.bg-refund {
    background: #17a2b8 !important;
}

.bg-cancellation {
    background: #dc3545 !important;
}

.widget-stat-btn {
    position: absolute;
    right: 30px;
    top: 20px;
    z-index: 1000;
}

.widget-stat-btn a {
    color: #000;
    opacity: .3;
    display: block;
    text-decoration: none;
}

.widget-stat-number {
    font-size: 45px;
    font-weight: 700;
    line-height: 1.2;
}

.widget-stat-title {
    font-size: 18px;
    line-height: 1.2;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
}

.widget-stat-btn a .fa {
    display: block;
    font-size: 13px;
}

.widget-stat-icon {
    width: 85px;
    height: 85px;
    float: left;
    font-size: 40px;
    color: #000;
}

.widget-stat-icon svg {
    width: 100%;
    height: auto;
}

.bg-success1 {
    background: #70D3FF !important;
}

.bg-primary1 {
    background: #39BF5E !important;
}

.widget-stat-info {
    margin-left: 20px;
    text-align: left;
}

.widget-stat-icon .widget-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: #fff;
    border-radius: 100px;
}

@media (max-width: 991px) {
    .row.gap-3 {
        margin-bottom: 20px;
    }
}
@media (max-width: 767px) {
    .widget-stat-icon {
        width: 60px;
        height: 60px;
    }
    .widget-stat-title {
        font-size: 16px;
    }
    .widget-stat-info {
        margin-left: 10px;
    }
    .widget-stat-number {
        font-size: 30px;
    }
    .widget.widget-stat {
        max-height: 120px;
        min-height: 120px;
    }
    .widget-stat-btn a {
        width: 40px;
        height: 40px;
    }
    .widget-stat-btn svg {
        max-width: 35px;
        height: 35px;
    }
}
</style>